import {
  ASSIGNMENTS_INDEX_REQUESTED,
  ASSIGNMENTS_INDEX_SUCCESS,
  ASSIGNMENTS_INDEX_FAILURE,
  ASSIGNMENTS_CREATE_REQUESTED,
  ASSIGNMENTS_CREATE_SUCCESS,
  ASSIGNMENTS_CREATE_FAILURE,
  ASSIGNMENTS_UPDATE_REQUESTED,
  ASSIGNMENTS_UPDATE_SUCCESS,
  ASSIGNMENTS_UPDATE_FAILURE,
  ASSIGNMENTS_DELETE_REQUESTED,
  ASSIGNMENTS_DELETE_SUCCESS,
  ASSIGNMENTS_DELETE_FAILURE,
  ASSIGNMENTS_BY_ITEM_REQUESTED,
  ASSIGNMENTS_BY_ITEM_SUCCESS,
  SEARCH_PRODUCT_REQUESTED,
  RESET_ASSIGNMENTS_STATE,
  ASSIGNMENTS_CSV_UPLOAD_REQUESTED,
  ASSIGNMENTS_CSV_UPLOAD_SUCCESS,
  ASSIGNMENTS_CSV_UPLOAD_FAILURE,
  ASSIGNMENTS_CSV_PROCESS_REQUESTED,
  ASSIGNMENTS_CSV_PROCESS_SUCCESS,
  ASSIGNMENTS_CSV_PROCESS_FAILURE,
  ASSIGNMENT_CREATE_REQUESTED,
  ASSIGNMENT_CREATE_SUCCESS,
  ASSIGNMENT_CREATE_FAILURE,
} from '../types';

const INITIAL_STATE = {
  assignments: [],
  relatedProducts: {},
  updatingAssignments: [],
  itemSearchingAssignments: [],
  itemAssignments: {},
  assignmentsSearchStack: [''],
  lastPage: true,
  newAssignmentsMessage: null,
  isFetching: false,
  status: 'waiting',
  uploadStatus: 'waiting',
  errors: null
};

const assignments = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case ASSIGNMENTS_INDEX_REQUESTED:
      return Object.assign({}, state, {
        assignments: [],
        relatedProducts: {},
        isFetching: true,
        status: 'requested',
        errors: null
      });

    case ASSIGNMENTS_INDEX_SUCCESS:
      newState.assignments = (action.payload.assignments || []);
      newState.relatedProducts = (action.payload.related_product_data || {});
      newState.isFetching = false;
      newState.status = 'success';
      newState.errors = null;
      newState.lastPage = action.payload.last_page;
      if(action.payload.continuation_token !== null) {
        newState.assignmentsSearchStack[action.page] = action.payload.continuation_token;
      }
      
      return newState;

    case ASSIGNMENTS_INDEX_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'error',
        errors: action.error
      });

    case ASSIGNMENT_CREATE_REQUESTED:
    case ASSIGNMENTS_CREATE_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requested',
        newAssignmentsMessage: null,
        errors: null
      });

    case ASSIGNMENTS_CREATE_SUCCESS:
      return Object.assign({}, state, {
        newAssignmentsMessage: action.payload.message,
        isFetching: false,
        status: 'created',
        errors: null
      });

    case ASSIGNMENT_CREATE_SUCCESS:
      newState.status = 'success';
      newState.isFetching = false;
      return newState;

    case ASSIGNMENT_CREATE_FAILURE:
    case ASSIGNMENTS_CREATE_FAILURE:
      return Object.assign({}, state, {
        assignments: {},
        isFetching: false,
        status: 'error',
        errors: action.error
      });

    case ASSIGNMENTS_UPDATE_REQUESTED:
      newState.updatingAssignments.push(action.assignmentId);
      newState.errors = null;
      return newState;

    case ASSIGNMENTS_UPDATE_SUCCESS:
      newState.updatingAssignments = newState.updatingAssignments.filter(assignmentId => assignmentId !== action.assignmentId);
      let toUpdate = newState.assignments.findIndex((assignment) => assignment?.product_id === action.response.product_id && assignment.variant_id === action.response.variant_id);

      if(toUpdate > -1) {
        newState.assignments[toUpdate]['supplier_sku'] = action.response['supplier_sku'];
        newState.assignments[toUpdate]['supplier_price'] = action.response['supplier_price'];
        newState.assignments[toUpdate]['minimum_order'] = action.response['minimum_order'];
        newState.assignments[toUpdate]['order_multiple'] = action.response['order_multiple'];
        newState.assignments[toUpdate]['pack_quantity'] = action.response['pack_quantity'];
      } else {

        // From assignments
        if(newState.itemAssignments[action.assignmentId]) {
          let body = {supplier_sku: action.response.supplier_sku, minimum_order: action.response.minimum_order, supplier_price: action.response.supplier_price, order_multiple: action.response.order_multiple, pack_quantity: action.response.pack_quantity}
          let supplierKey = `Supplier-${action.response.supplier_id}`;
          let target = newState.itemAssignments[action.assignmentId].find(metafield => metafield.key === supplierKey);
          target.value = JSON.stringify(body);
        } else {
          // From a search

        }
      }

      return newState;

    case ASSIGNMENTS_UPDATE_FAILURE:
      newState.updatingAssignments.filter(assignmentId => assignmentId !== action.assignmentId);
      newState.errors = 'Failed to update assignment';
      return newState


    case ASSIGNMENTS_DELETE_REQUESTED:
      newState.updatingAssignments.push(action.assignmentId);
      newState.errors = null;
      return newState;

    case ASSIGNMENTS_DELETE_SUCCESS:
      // console.log(action.response);
      // console.log(action.response['data']);

      newState.updatingAssignments = newState.updatingAssignments.filter(assignmentId => assignmentId !== action.assignmentId);
      let toDelete = newState.assignments.findIndex((assignment) => assignment?.product_id === action.response['data'].product_id && assignment.variant_id === action.response['data'].variant_id);

      if(toDelete > -1) {
        delete newState.assignments[toDelete];
        newState.assignments.filter(n => n);
      }

      let supplierKey = `Supplier-${action.response['data'].supplier_id}`;
      let metaIndex = newState.itemAssignments[action.assignmentId]?.findIndex(metafield => metafield?.key === supplierKey);

      if(metaIndex > -1) {
        delete newState.itemAssignments[action.assignmentId][metaIndex];
        newState.itemAssignments[action.assignmentId].filter(n => n);
      }

      // console.log(newState.assignments);
      // console.log(newState.itemAssignments);

      return newState;

    case ASSIGNMENTS_DELETE_FAILURE:
      newState.errors = 'Failed to delete assignment';
      return newState

    case SEARCH_PRODUCT_REQUESTED:
      newState.itemSearchingAssignments = [];
      newState.itemAssignments = {};
      return newState;

    case ASSIGNMENTS_BY_ITEM_REQUESTED:
      return Object.assign({}, state, {
        itemSearchingAssignments: [...state.itemSearchingAssignments, action.itemKey]
      });

    case ASSIGNMENTS_BY_ITEM_SUCCESS:
      newState.itemSearchingAssignments = newState.itemSearchingAssignments.filter(item => item !== action.itemKey);
      if(action.response?.assignments?.data?.length > 0) { newState.itemAssignments[action.itemKey] = (action?.response?.assignments?.data); }
      return newState;

    case RESET_ASSIGNMENTS_STATE:
      newState.assignmentsSearchStack = [''];
      newState.assignments = [];
      newState.relatedProducts = {} ;
      newState.updatingAssignments = [];
      newState.itemSearchingAssignments = [];
      newState.itemAssignments = {};
      newState.lastPage = true;
      newState.newAssignmentsMessage = null;
      newState.isFetching = false;
      newState.status = 'waiting';
      newState.errors = null;
      return newState;

    case ASSIGNMENTS_CSV_UPLOAD_REQUESTED:
      newState.uploadStatus = 'uploading';
      return newState;

    case ASSIGNMENTS_CSV_UPLOAD_SUCCESS:
      newState.uploadStatus = 'uploaded';
      return newState;

    case ASSIGNMENTS_CSV_PROCESS_REQUESTED:
      newState.uploadStatus = 'processing_requested';
      return newState;

    case ASSIGNMENTS_CSV_PROCESS_SUCCESS:
      newState.uploadStatus = 'processing';
      return newState;

    case ASSIGNMENTS_CSV_UPLOAD_FAILURE:
    case ASSIGNMENTS_CSV_PROCESS_FAILURE:
      newState.uploadStatus = 'failure';
      return newState;

    default:
      return state;
  }
}

export default assignments;
